import React, { FC, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { notifyOwnHeaderShown } from '@utils';

import Header from '../header';

import { StatusScreenProps, StatusIconProps } from './types';

const useStyles = makeStyles(() => ({
  screen: {
    display: 'flex',
    flexDirection: 'column',
    minBlockSize: '100dvh',
    backgroundColor: '#1c1c1c',
    color: '#fff'
  },
  screen__content: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px 16px',
    textAlign: 'center'
  },
  screen__iconWrap: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '40px'
  },
  screen__glow: {
    position: 'absolute',
    inlineSize: '300px',
    blockSize: '300px',
    borderRadius: '50%',
    filter: 'blur(60px)',
    background: 'radial-gradient(circle, rgba(248, 214, 139, 0.35) 0%, rgba(248, 214, 139, 0) 70%)',
    pointerEvents: 'none'
  },
  screen__title: {
    position: 'relative',
    margin: '0 0 12px',
    maxInlineSize: '343px',
    fontSize: '18px',
    lineHeight: '24px',
    fontWeight: 700
  },
  screen__text: {
    position: 'relative',
    margin: 0,
    maxInlineSize: '343px',
    fontSize: '14px',
    lineHeight: '22px',
    fontWeight: 400
  },
  screen__footer: {
    padding: '16px 24px calc(24px + env(safe-area-inset-bottom))'
  },
  screen__button: {
    display: 'block',
    inlineSize: '100%',
    blockSize: '48px',
    padding: '0 16px',
    border: 0,
    borderRadius: '8px',
    background: 'linear-gradient(180deg, #f4daa2 -6.15%, #e5c78a 23.7%, #d3b272 53.54%, #a68141 83.38%, #845f23 113.23%)',
    color: '#000',
    fontFamily: 'inherit',
    fontSize: '14px',
    lineHeight: '16px',
    fontWeight: 700,
    cursor: 'pointer',
    '&:focus-visible': {
      outline: '2px solid #ffd47f',
      outlineOffset: '2px'
    }
  },
  icon: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    inlineSize: '100px',
    blockSize: '100px',
    borderRadius: '50%'
  },
  icon_background: {
    backgroundColor: 'rgba(226, 195, 134, 0.2)'
  },
  icon__image: {
    display: 'block'
  }
}));

export const StatusIcon: FC<StatusIconProps> = ({ src, size, withBackground = false }) => {
  const classes = useStyles();
  const className = withBackground ? `${classes.icon} ${classes.icon_background}` : classes.icon;

  return (
    <span className={className}>
      <img src={src} width={size} height={size} alt="" className={classes.icon__image} />
    </span>
  );
};

export const StatusScreen: FC<StatusScreenProps> = ({
  headerTitle,
  icon,
  title,
  text,
  buttonLabel,
  onButtonClick,
  onBack,
  onClose,
  testId
}) => {
  const classes = useStyles();

  useEffect(() => {
    notifyOwnHeaderShown();
  }, []);

  return (
    <div className={classes.screen} data-test-id={testId}>
      <Header title={headerTitle} onBack={onBack} onClose={onClose} />
      <main className={classes.screen__content}>
        <div className={classes.screen__iconWrap}>
          <div className={classes.screen__glow} />
          {icon}
        </div>
        <h2 className={classes.screen__title}>{title}</h2>
        <p className={classes.screen__text}>{text}</p>
      </main>
      <div className={classes.screen__footer}>
        <button
          type="button"
          onClick={onButtonClick}
          className={classes.screen__button}
          data-test-id="payment-form-action-button"
        >
          {buttonLabel}
        </button>
      </div>
    </div>
  );
};

export default StatusScreen;
